<script>
import { iBadge, iBadgeColours } from '@inscribe/signal';

const VerificationOutcome = {
  UNMATCHED: 'UNMATCHED',
  PARTIALLY_MATCHED: 'PARTIALLY_MATCHED',
  MATCHED: 'MATCHED',
};

const BadgePropertiesEnum = {
  [VerificationOutcome.UNMATCHED]: {
    label: 'Unmatched',
    colour: iBadgeColours.ERROR,
    icon: 'small-alert-triangle',
  },
  [VerificationOutcome.PARTIALLY_MATCHED]: {
    label: 'Partially matched',
    colour: iBadgeColours.WARNING,
    icon: 'small-alert-circle',
  },
  [VerificationOutcome.MATCHED]: {
    label: 'Matched',
    colour: iBadgeColours.SUCCESS,
    icon: 'small-check-circle',
  },
};

export default {
  components: { iBadge },
  props: {
    salaryCrossCheckVerification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { iBadgeColours };
  },
  computed: {
    riskBadgeProperties() {
      return BadgePropertiesEnum[this.salaryCrossCheckVerification.outcome];
    },
  },
  methods: {
    formatAmount(amount) {
      return parseFloat(amount).toFixed(2);
    },
  },
};
</script>

<template>
  <div class="d-flex flex-column align-items-start i-gap-4 i-pr-10">
    <div class="i-text-subheading-3 i-text-neutral-120">
      Payslip cross-checked with salary transactions
    </div>

    <i-badge
      :colour="riskBadgeProperties.colour"
      :icon="riskBadgeProperties.icon"
      :label="riskBadgeProperties.label"
      :has-leading-icon="true"
      :interactable="true"
    ></i-badge>

    <div class="summary i-text-body-3 i-text-neutral-120">
      {{ salaryCrossCheckVerification.rationale }}
    </div>

    <div
      v-for="item in salaryCrossCheckVerification.salary_cross_check_items"
      :key="item.id"
      class="i-text-body-3 i-text-neutral-120"
    >
      <strong>
        ({{ item.salary_transaction.tx_date }}) ${{
          formatAmount(item.salary_transaction.tx_amount),
        }}
      </strong>
      - {{ item.rationale }}
    </div>
  </div>
</template>
<style scoped lang="scss">
.summary {
  border-bottom: 1px solid $light-neutral-60;
  padding-bottom: map-get($increments, 4);
  margin-bottom: map-get($increments, 2);
}
</style>
